import { motion } from "motion/react";
import { forwardRef } from "react";
import { AcfMediaFragment } from "@/__generated__/graphql";
import { toProxiedWpUrl, toProxiedWpSrcSet } from "@/utils/wpMediaUrl";

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  image: AcfMediaFragment;
  imageRef?: React.RefObject<HTMLImageElement>;
  useTitleFallback?: boolean;
  style?: React.CSSProperties;
}

const Image = forwardRef<HTMLImageElement, ImageProps>(
  (
    {
      className,
      image,
      style,
      useTitleFallback,
      sizes = "100vw",
      ...rest
    },
    ref
  ) => {
    const altText = image?.node.altText || (useTitleFallback ? image?.node.title : "");
    return (
      <img
        ref={ref}
        className={className}
        src={!image?.node.srcSet ? toProxiedWpUrl(image?.node.mediaItemUrl) : undefined}
        srcSet={toProxiedWpSrcSet(image?.node.srcSet)}
        width={image?.node.mediaDetails.width || undefined}
        height={image?.node.mediaDetails.height || undefined}
        alt={altText}
        style={style}
        sizes={sizes}
        {...rest}
      />
    );
  }
);

export default motion.create(Image);
